import React from "react";
import Layouts from "../../Components/Layouts/Layouts";
import Section2 from "./Section2.js";
import "../../styles/AboutStyle.css";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <>
      <Helmet>
        <title>About Us | Martial Arts Seminars & Training Events USA</title>

        <meta
          name="description"
          content="Learn more about Spectacular Seminars, a leading platform for martial arts seminars, tournaments, instructor workshops, and professional training events across the USA."
        />

        <meta
          name="keywords"
          content="about spectacular seminars, martial arts seminars USA, martial arts training events, karate workshops, taekwondo seminars, MMA training, martial arts tournaments, self defense seminars, martial arts instructors, martial arts schools USA, professional martial arts events, martial arts community, combat sports seminars, martial arts education"
        />
      </Helmet>
      <Layouts>
        <Section2 />
      </Layouts>
    </>
  );
}
export default About;
